import { notificationCenterUrl, patientListUrl } from "../../utils/constants";
export const getSpecialTabIdentification = (url = "") => {
    url = url.toLowerCase();
    if (url.includes(patientListUrl.toLowerCase())) {
        return "tab-patientselection";
    }
    else if (url.includes(notificationCenterUrl.toLowerCase())) {
        return "tab-docked-notificationcenter";
    }
    return "";
};
export const getDockedTabIdentification = (tab) => getSpecialTabIdentification(tab.url) ||
    `tab-docked-${formatValue(tab.menuId)}`;
export const getTabIdentification = (tab) => getSpecialTabIdentification(tab.url) ||
    `tab-${formatValue(tab.VisID)}-${formatValue(tab.menuId)}`;
const formatValue = (value) => value || undefined;
